import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'

const CareerIntro = ({ title, subtitle, images, ctaText, ctaUrl }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.descriptionBox}>
          <div className={styles.vCenter}>
            {typeof window !== `undefined` && window.innerWidth <= 450 && (
              <h2 className={styles.title}>{title}</h2>
            )}
            {typeof window !== `undefined` && window.innerWidth > 450 && (
              <h2 className={styles.title}>{title}</h2>
            )}
            <div className={styles.subtitle}>{subtitle.subtitle}</div>
          </div>
        </div>
        <div className={styles.imageBox}>
          <GatsbyImage
            image={images[0].gatsbyImageData}
            style={{ height: '100%', width: '100%' }}
            alt={images[0]?.description}
          />
        </div>
      </div>
    </div>
  )
}

export default CareerIntro
